<template>
  <el-dialog
    class="dialog"
    title="设置税率"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="true"
    top="5vh"
    append-to-body
    z-index="1000"
    @close="closeDialog"
  >
    <el-form
      :model="formData"
      :rules="formRules"
      label-width="100px"
      label-suffix="："
    >
      <el-form-item label="税率" prop="tariff">
        <div class="flex">
          <el-input-number
            v-model="formData.tariff"
            placeholder="设置所有品目的税率"
            :precision="2"
            :max="100"
            :min="0"
            controls-position="right"
          />
          <span class="m-l-10">%</span>
        </div>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button size="medium" @click="visible = false">
        取 消
      </el-button>
      <el-button type="primary" size="medium" @click="confirm">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'SetTariffDialog',

  model: {
    prop: 'showDialog',
    event: 'change'
  },

  props: {
    showDialog: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      formData: {
        tariff: 0
      },
      formRules: {
        tariff: [
          {
            required: true,
            message: '请输入品目税率',
            trigger: ['change', 'blur']
          }
        ]
      }
    }
  },

  computed: {
    visible: {
      get() {
        return this.showDialog
      },
      set(val) {
        this.$emit('update:showDialog', val)
      }
    }
  },

  methods: {
    closeDialog() {
      this.formData.tariff = 0
    },

    confirm() {
      this.$emit('confirm', this.formData.tariff)
      this.visible = false
    }
  }
}
</script>

<style scoped></style>
